export default __webpack_public_path__ + "static/media/apiago1.5cc313b6.jpg";